module.exports = "/images/delete1.svg?aa7293c30b8669d3ea8a22a940c6e9fa";